import { setInviteMemberModal } from '../../../../../store/workspace/slice';
import { validateEmail } from '../../../../../utils/generalHelpers';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';
import {
    getProfileDataThunk,
    sendMemberInvitationThunk,
} from '../../../../../store/workspace/thunks';
import {
    CopyIcon,
    CheckSolidIcon,
    InviteMemberIcon,
    SuccessfulEmailIcon,
} from '../../../../../assets/icons';

type Step = 'Form' | 'Done';

/** How long the "copied" tick stays on the invitation link. */
const COPIED_FEEDBACK_MS = 2000;

export default function InviteMember() {
    const dispatch = useDispatch();
    const [link, setLink] = useState('');
    const [email, setEmail] = useState('');
    const [copied, setCopied] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [step, setStep] = useState<Step>('Form');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const closeModal = () => dispatch(setInviteMemberModal(false));

    const copyToClipboard = () => {
        navigator?.clipboard?.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
        });
    };

    const next = () => {
        if (step === 'Done') {
            closeModal();
            return;
        }

        if (!validateEmail(email)) {
            setEmailError('Email address is invalid.');
            return;
        }

        setIsLoading(true);
        setErrorMessage('');
        setEmailError('');

        dispatch(sendMemberInvitationThunk({ email }))
            .unwrap()
            .then((response) => {
                setStep('Done');
                setLink(response.invitationLink);
                dispatch(getProfileDataThunk());
            })
            .catch(() => {
                setErrorMessage('Error');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            closeFunc={closeModal}
            title='Add member seat'
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            actions={step === 'Form' ? 'both' : 'confirm'}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: step === 'Form' ? 'Send link' : 'Ok',
                type: 'Primary',
                onClick: next,
                loading: isLoading,
            }}
        >
            {step === 'Form' && <div className={styles.form}>
                <span>
                    Please enter the email address of
                    the person you want to add as a member.
                </span>
                <Input
                    type='email'
                    value={email}
                    label='Email address'
                    onChange={setEmail}
                    error={emailError}
                    hasError={Boolean(errorMessage)}
                />
            </div>}

            {step === 'Done' && <div className={styles.success}>
                <SuccessfulEmailIcon />
                <span>Invitation email sent successfully</span>
                <div className={styles.success_link} onClick={copyToClipboard}>
                    <span>{link}</span>
                    {copied ? <CheckSolidIcon /> : <CopyIcon />}
                </div>
            </div>}

            {errorMessage && <span className={styles.error}>{errorMessage}</span>}
        </Modal>
    );
};
